import { compose, bindActionCreators  } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import dataFetcher from "../../parts/chore/dataFetcher";
import { searchMessages, clearSearch } from '../../search/searchActions';
import { fetchConversation, markAsUnread, blockUser, sendMessage, deleteConversation, updateMessage } from '../../messages/messageActions';
import { Form } from 'antd';

import UserInboxForm from './UserInboxForm';

const mapStateToProps = state => ({
    member: state.member.member,
    messages: state.search.messages.results,
    pagination: state.search.messages.pagination,
    fetchTime: state.search.messages.fetchTime,
    locale: state.session.language,
    selectedConversation: state.message.selectedConversation.results,
    batchNumber: state.message.selectedConversation.batchNumber,
    bottomReached: state.message.selectedConversation.bottomReached,
    conversationFetchTime: state.message.conversationFetchTime,
    search: state.search.messages.search,
    session: state.session,
    isSendMessageInProgress: state.message.isSendMessageInProgress,
    accentColors: state.platform.platform.settings.color,
    platformId: state.platform.platform.id,
    isFetchConversationInProgress: state.message.isFetchConversationInProgress
});

const mapDispatchToProps = dispatch => bindActionCreators({
  searchMessages,
  fetchConversation,
  markAsUnread,
  blockUser,
  clearSearch,
  sendMessage,
  deleteConversation,
  updateMessage
 }, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  Form.create(),
  dataFetcher
)(UserInboxForm);